import { Component, Input, OnInit } from '@angular/core';
import { EvalReason, EvaluationVehicle } from '@app-model/evaluation';

@Component({
  selector: 'app-card-owner-info',
  templateUrl: './card-owner-info.component.html',
  styleUrls: ['./card-owner-info.component.scss']
})
export class CardOwnerInfoComponent implements OnInit {

  @Input() vehicle: EvaluationVehicle;
  constructor() { }

  ngOnInit(): void {
  }

  get evalReasonLabel(): string {
    let result = EvalReason.getLabel(this.vehicle.evalReason);
    if ((EvalReason.isOther(this.vehicle.evalReason) || EvalReason.isDirectSell(this.vehicle.evalReason))
      && this.vehicle.otherEvalReason) {
      result += ' - ' + this.vehicle.otherEvalReason;
    }
    return result;
  }

}
